import { ChangeEvent, useCallback, useEffect, useState } from "react";

import TextBoxMarkup from "./markup";
import { InputMode, InputType, Props } from "./types";

export function TextBox(props: Props) {
	const [value, setValue] = useState(props.value);

	useEffect(() => {
		//If empty value and prefix, set to prefix
		if (!props.value && props.prefix) props.changeHandler(props.prefix, props.id);
		setValue(props.value || props.prefix);
	}, [props.value]);

	const updateValue = useCallback(
		function (newValue: any) {
			if (!props.maxlength || newValue.length <= props.maxlength) {
				setValue(newValue);
				props.changeHandler(newValue, props.id);
			}
		},
		[setValue, props.changeHandler],
	);

	/**
	 * On change handler. Calls valid function if provided and then calls the change
	 * handler
	 * @param event
	 */
	const onChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			const element = event.target;
			updateValue(element.value);
		},
		[updateValue],
	);

	const onChangeValue = useCallback(
		(newValue: any) => {
			if (newValue !== props.value) updateValue(newValue);
			//We want the masking thing to handle it's own cursor position
			//updateCursor(_inputEl.current);
		},
		[updateValue],
	);

	return <TextBoxMarkup {...props} onChange={onChange} onChangeValue={onChangeValue} value={value} />;
}

export default TextBox;

export type { InputType, InputMode };
